import styled from 'styled-components'

import { DEVICE } from '@/utils/constants/breakpoints'

export const Container = styled.div`
  main {
    max-width: 100vw;
  }

  padding: 0 1.25rem;

  @media ${DEVICE.tablet} {
    padding: 6.938rem 10.438rem;
  }

  section {
    display: flex;
    gap: 2.5rem;
    flex-direction: column;

    @media ${DEVICE.tablet} {
      margin-top: 5.375rem;
      flex-direction: row;
      gap: 14.5rem;
    }
  }

  h1 {
    text-align: left;
    font: normal normal 600 3.688rem/3.625rem
      ${(props) => props.theme.fonts.second};
    letter-spacing: 0px;
    color: #06152b;
    opacity: 1;

    @media ${DEVICE.tablet} {
      font: normal normal 600 4.688rem/4.625rem
        ${(props) => props.theme.fonts.second};
    }
  }

  > p {
    text-align: left;
    font: normal normal 600 1rem/1.5rem ${(props) => props.theme.fonts.primary};
    letter-spacing: -0.1px;
    color: ${(props) => props.theme.colors.base100};
    opacity: 1;
    max-width: 707px;

    @media ${DEVICE.tablet} {
      font: normal normal 600 1.5rem/2rem
        ${(props) => props.theme.fonts.primary};
    }
  }
`

export const Summary = styled.nav`
  max-width: 576px;
  width: 100%;

  ul {
    display: flex;
    flex-direction: column;

    li {
      padding: 1.5rem 0 1rem;
      text-align: left;
      letter-spacing: -0.72px;
      color: #128fc6;
      font: normal normal bold 1.5rem/1.875rem
        ${(props) => props.theme.fonts.second};
    }

    li + li {
      border-top: 1px solid rgba(151, 184, 200, 0.3);
    }
  }
`

export const Clauses = styled.article`
  max-width: 677px;
  width: 100%;
  text-align: left;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  h6 {
    letter-spacing: -0.72px;
    color: ${(props) => props.theme.colors.primary};
    font: normal normal bold 1.25rem/1.625rem
      ${(props) => props.theme.fonts.primary};
    margin: 0;
  }

  article {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 0.8rem;
  }

  p,
  li,
  ul {
    text-align: left;
    font: normal normal 500 1rem/1.625rem
      ${(props) => props.theme.fonts.primary};
    letter-spacing: 0px;
    color: ${(props) => props.theme.colors.base800};
    margin: 0;
  }
`

export const SeparatorSection = styled.section`
  width: 100%;
  height: 400px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const OnlyMobile = styled.div`
  display: block;
  @media ${DEVICE.tablet} {
    display: none !important;
  }
`

export const OnlyDesktop = styled.div`
  display: none;
  @media ${DEVICE.tablet} {
    display: flex;
  }
`
